import { ComponentOptions } from "../../../framework/components/components/component";
import { TemplateComponent } from "../../../framework/components/components/templateComponent";
import K_LoginHeader from "../templates/K_LoginHeader";

export interface LoginHeaderOptions extends ComponentOptions {
    title?: string;
    src?: string;
    bsc?: string;
}

export class LoginHeader extends TemplateComponent {

    options: LoginHeaderOptions;

    constructor(options: LoginHeaderOptions) {
        super(K_LoginHeader, options);
    }

    preRender() {
        const options = this.options;

        options.title = options.title || "";
        options.src = options.src || "";
    }

}
